import styled from 'styled-components';
import colors from 'constants/colors';

export const Head = styled.div`
  position: relative;
  font-size: 22px;
  font-weight: 600;
  color: ${colors.green};
  margin-bottom: 16px;
`;

export const BillItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: ${colors.black1};
  row-gap: 8px;
  padding: 16px;
  margin-top: 16px;

  .title {
    width: 100%;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
  }
`;

export const ItemContainer = styled.tr`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;

  .description {
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.white};
  }

  .value {
    font-size: 14px;
    font-weight: 700;
    color: ${colors.white};
  }

  th {
    color: ${colors.silver};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }

  .approval {
    color: ${colors.green};
  }

  .warning {
    color: ${colors.red};
  }

  .normal {
    color: ${colors.white};
  }

  .lineThrough {
    text-decoration: line-through;
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.darkGrey};
  margin: 16px 0;
`;

export const Footer = styled.div`
  font-weight: 300;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 24px;
`;
